import { createSelector } from 'reselect';
const issueState = (state) => state.issue;
export const itemsIssueSelector = createSelector(issueState, (issue) => issue.items);
export const selectedItemIssueSelector = createSelector(issueState, (issue) => issue.selectedItem);
export const searchValueIssueSelector = createSelector(issueState, (issue) => issue.searchValue);
export const sortSelectedItemIssueSelector = createSelector(issueState, (issue) => issue.sortSelectedItem);
export const sortItemsIssueSelector = createSelector([itemsIssueSelector, sortSelectedItemIssueSelector, searchValueIssueSelector], (items, sortSelectedItem, searchValue) => {
    const compareFn = (a, b) => {
        var _a, _b, _c, _d;
        switch (sortSelectedItem.name) {
            case 'transport_number':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return b.transport_number == null
                            ? -1
                            : a.transport_number == null
                                ? 1
                                : a.transport_number.localeCompare(b.transport_number, undefined, { sensitivity: 'base' });
                    case 'DESC':
                        return b.transport_number == null
                            ? -1
                            : a.transport_number == null
                                ? 1
                                : b.transport_number.localeCompare(a.transport_number, undefined, { sensitivity: 'base' });
                }
                break;
            case 'created_at':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return moment(a[sortSelectedItem.name]).valueOf() - moment(b[sortSelectedItem.name]).valueOf();
                    case 'DESC':
                        return moment(b[sortSelectedItem.name]).valueOf() - moment(a[sortSelectedItem.name]).valueOf();
                }
                break;
            case 'status':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return String((_a = a.status) !== null && _a !== void 0 ? _a : '').localeCompare(String((_b = b.status) !== null && _b !== void 0 ? _b : ''), undefined, { sensitivity: 'base' });
                    case 'DESC':
                        return String((_c = b.status) !== null && _c !== void 0 ? _c : '').localeCompare(String((_d = a.status) !== null && _d !== void 0 ? _d : ''), undefined, { sensitivity: 'base' });
                }
                break;
            default:
                switch (typeof a[sortSelectedItem.name]) {
                    case 'string':
                        switch (sortSelectedItem.order) {
                            case 'ASC':
                                return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
                            case 'DESC':
                                return b.title.localeCompare(a.title, undefined, { sensitivity: 'base' });
                        }
                        break;
                    case 'number':
                        switch (sortSelectedItem.order) {
                            case 'ASC':
                                return Number(a[sortSelectedItem.name]) - Number(b[sortSelectedItem.name]);
                            case 'DESC':
                                return Number(b[sortSelectedItem.name]) - Number(a[sortSelectedItem.name]);
                        }
                        break;
                }
        }
        return 0;
    };
    if (searchValue.length) {
        return [...items].filter((item) => item.title.indexOf(searchValue) !== -1).sort(compareFn);
    }
    return [...items].sort(compareFn);
});
